import React from 'react';

import { Typography, Box } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';

import CloseIcon from '../../assets/icons/CloseIcon';
import LinkedInIcon from '../../assets/icons/LinkedInIcon';
import { colorsPalette } from '../../theme';
import { CardWrapper } from '../UI/CardWrapper';
import { ShareButton } from '../UI/ShareButton';
import useStyles from './styles';

export const generateLinkedInUrl = (name, certDate, certUrl, linkedInId) => {
  const date = new Date(certDate);
  const year = date.getFullYear();
  const month = date.getMonth();

  return `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${name}+Pathway&organizationId=${linkedInId}&issueYear=${year}&issueMonth=${month}&certUrl=${certUrl}`;
};

interface LinkedInModalProps {
  handleClose: () => void;
  pathwayName?: string | null;
  resultHash?: string | null;
  passDate?: string | null;
  linkedInId?: string | null;
  certUrl?: string | null;
}

const LinkedInModal: React.FC<LinkedInModalProps> = ({
  handleClose,
  pathwayName,
  passDate,
  resultHash,
  linkedInId,
  certUrl,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const linkedInUrl = generateLinkedInUrl(
    pathwayName,
    passDate,
    certUrl || `${window?.location?.origin}/share/${resultHash}`,
    linkedInId,
  );

  return (
    <CardWrapper wrapperClass={classes.wrapper}>
      <Box className={classes.headerWrapper}>
        <Typography variant="h2" className={classes.title}>
          {t('page.test.addToLinkedIn')}
        </Typography>
        <CloseIcon color={colorsPalette.gray} className={classes.closeIcon} onClick={handleClose} />
      </Box>
      <Typography className={classes.description}>
        <Trans i18nKey="page.test.addToLinkedInDescr">
          Add your certification for <strong>{{ pathwayName }}</strong> to LinkedIn following the
          steps below.
        </Trans>
      </Typography>
      <ol className={classes.list}>
        <li className={classes.listItem}>
          <Typography className={classes.listCounter}>1</Typography>
          <a href={linkedInUrl} target="_blank" rel="noopener noreferrer">
            <ShareButton wrapperClass={classes.shareButton}>
              <LinkedInIcon color={colorsPalette.white} />
              {t('page.test.linkedIn')}
            </ShareButton>
          </a>
        </li>
        <li className={classes.listItem}>
          <Typography className={classes.listCounter}>2</Typography>
          {t('page.test.credentialExpire')}
        </li>
        <li className={classes.listItem}>
          <Typography className={classes.listCounter}>3</Typography>
          {t('page.test.credentialId')}
        </li>
        <li className={classes.listItem}>
          <Typography className={classes.listCounter}>4</Typography>
          {t('page.test.clickSave')}
        </li>
      </ol>
    </CardWrapper>
  );
};

export default LinkedInModal;
